import { useEffect } from 'react';
import GlobalContext from '../GlobalProvider';
import { useContext } from 'react';
import Header from '../Header';
import Container from './Container';
import Stepper from './Stepper';
import Chart from './Chart';
import FormatMoney from './FormatMoney';

function Pension() {
  const { state } = useContext(GlobalContext);

  // Format the value if the state has data
  const formattedValue_rsa = state?.data?.total_rsa_bal
    ? '₦' + FormatMoney(state.data.total_rsa_bal)
    : '₦0'; // Default value if data is null

  // Log initial state
  useEffect(() => {
  }, []);

  // Log state changes
  useEffect(() => {
  }, [state]);

  return (
    <>
    <div>
      <Header />
    </div>
    <div className="flex flex-col sm:flex-row mx-auto justify-center h-3/5 m-10 mb-0 mt-0 bg-slate-50 border-3 border-green-900 items-center">
      <div className='w-fit lg:w-full p-4 m-4'>
        <Container
          PropComponent={Stepper}
          heading={'Pension Calculator'}
          text={'Not sure about how much to save for retirement? Our Pension Calculator can help'}
        />
      </div>
      <div className='w-fit lg:w-full p-4 m-4'>
        <Container
          PropComponent={Chart}
          heading={formattedValue_rsa}
          text={'Would be your estimated RSA balance at retirement'}
        />
      </div>
    </div>

    </>
  );
}

export default Pension;
